// extracted by mini-css-extract-plugin
export default {"nav":"SideNav_nav__sn837","activeTab":"SideNav_activeTab__8eMTb","separator":"SideNav_separator__BeUbc"};